var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.501 4C8.082 4 4.5 7.582 4.5 11.999C4.5 15.276 6.47 18.09 9.289 19.327C9.265 18.768 9.284 18.098 9.427 17.491C9.582 16.841 10.457 13.131 10.457 13.131C10.457 13.131 10.202 12.62 10.202 11.865C10.202 10.679 10.889 9.794 11.744 9.794C12.473 9.794 12.823 10.341 12.823 10.995C12.823 11.726 12.357 12.821 12.118 13.834C11.917 14.683 12.543 15.375 13.379 15.375C14.896 15.375 15.917 13.428 15.917 11.122C15.917 9.369 14.736 8.056 12.588 8.056C10.161 8.056 8.65 9.866 8.65 11.887C8.65 12.584 8.854 13.076 9.177 13.456C9.324 13.631 9.345 13.702 9.291 13.902C9.253 14.049 9.165 14.404 9.128 14.544C9.075 14.747 8.911 14.819 8.728 14.745C7.61 14.288 7.09 13.065 7.09 11.688C7.09 9.416 9.007 6.691 12.807 6.691C15.862 6.691 17.873 8.901 17.873 11.273C17.873 14.412 16.127 16.757 13.555 16.757C12.691 16.757 11.879 16.289 11.601 15.759C11.601 15.759 11.136 17.603 11.038 17.958C10.868 18.574 10.536 19.192 10.233 19.672C10.969 19.89 11.733 20 12.501 20C16.919 20 20.5 16.418 20.5 11.999C20.5 7.582 16.919 4 12.501 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPin);
export default __webpack_public_path__ + "static/media/social-pin.2c90fb9054ed8f939939b49f683e0ca4.svg";
export { ForwardRef as ReactComponent };